@let forbiddenPermissionsMessage = 'general.forbidden_action' | translate;

<form [formGroup]="form">
  <div class="row">
    <div class="w-100">
      <div class="row">
        <div class="w-100">
          <div class="d-flex content"></div>
        </div>
        <div class="form-group input-field">
          <label class="form-label mb-0" for="websiteUrl">
            {{ 'page.general_settings.info.website' | translate }}
          </label>
          <input
            class="br-0 rounded-0"
            nz-input
            required
            name="website"
            formControlName="websiteUrl"
            type="text"
            nz-tooltip
            [nzTooltipTitle]="
              !hasGeneralSettingsUpdatePermission
                ? forbiddenPermissionsMessage
                : ''
            "
            [placeholder]="'general.input' | translate"
            (blur)="onInfoDetailsChange()"
          />
        </div>
        <div class="form-group input-field">
          <label for="email">
            {{ 'page.general_settings.info.email' | translate }}
          </label>
          <input
            [class.is-invalid]="
              (form.controls['email'] | formControlInvalid) ||
              form.controls['email'].invalid
            "
            type="email"
            class="rounded-0"
            id="email"
            nz-input
            formControlName="email"
            placeholder="{{ 'general.input' | translate }}"
            nz-tooltip
            [nzTooltipTitle]="
              !hasGeneralSettingsUpdatePermission
                ? forbiddenPermissionsMessage
                : ''
            "
            (blur)="onInfoDetailsChange()"
          />
        </div>
        <div class="form-group input-field">
          <label class="form-label mb-0" for="phone">
            {{ 'page.general_settings.info.phone' | translate }}
          </label>
          <input
            class="br-0 rounded-0"
            nz-input
            nz-tooltip
            [nzTooltipTitle]="
              !hasGeneralSettingsUpdatePermission
                ? forbiddenPermissionsMessage
                : ''
            "
            required
            [placeholder]="'general.input' | translate"
            name="website"
            formControlName="phone"
            type="text"
            (blur)="onInfoDetailsChange()"
          />
        </div>
      </div>
    </div>
  </div>
</form>
